import { Options, Vue } from 'vue-class-component';
import { getMenuTree } from "@/api/index";
import { NavsDto } from '@/model/web/NavsDto';
import Title from '../title/Title.vue';
@Options({
    components: {
        Title,
    }
})
export default class Main extends Vue {
    public key = '';

    public created() {
        this.key = this.$route.path;
    //    console.log(this.key);

    }

}
